var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "role_container" }, [
    _c(
      "div",
      { staticClass: "sel" },
      [
        _c(
          "a-select",
          {
            staticStyle: { width: "200px" },
            attrs: {
              mode: "multiple",
              placeholder: "请选择",
              value: _vm.selectedItems,
              open: _vm.selectOpen
            },
            on: { change: _vm.handleChange }
          },
          _vm._l(this.filteredOptions, function(item) {
            return _c(
              "a-select-option",
              { key: item[_vm.configData.primaryKey] },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(item[_vm.configData.displayKey]) +
                    "\n      "
                )
              ]
            )
          }),
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "but" },
      [
        _c(
          "a-button",
          {
            on: {
              click: function($event) {
                return _vm.modelVisible(true)
              }
            }
          },
          [_vm._v("选择")]
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c("select-component-model", {
          ref: "modelList",
          attrs: {
            closeModel: _vm.modelVisible,
            configData: _vm.configData,
            fatcherSelectedItems: _vm.selectedItems,
            multiple: _vm.multiple
          },
          on: { selectSubmit: _vm.selectSubmit }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }